import React from 'react'
import { Link } from 'react-router-dom'
import "./heroImg.css"
import hero from "../Assets/pexels-ola-dapo-3521937.jpg"
function HeroImg() {
  return (
    <div className='hero'>
        <div className='mask'>
            <img className='intro-img' src={hero} alt='intro'/>
        </div>
        <div className='content'>
            <p>HELLO. I AM A </p>
            <h1>JUNIOR CYBER SECURITY CONSULTANT</h1>
            <div>
                <Link to={"/projects"} className='btn'>PROJECTS</Link>
                <Link to={"/contact"} className='btn btn-light'>CONTACT</Link>
            </div>
        </div>
    </div>
  )
}

export default HeroImg